export default __webpack_public_path__ + "static/media/bamboomantra.98059975.ogg";